import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_350t9wyo: FaireBrandEntity = {
  token: "b_350t9wyo",
  type: "brand",
  name: "Best Beauty Group",
  avatarUrl:
    "https://cdn.faire.com/fastly/7ea178eb65d7cd62834fdd2d335089d76e5db43c7a4ef31743b6e855c41a2294.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e3af48a72cbd424ccb70ba5dc8312b97937477a7127afe0cecab4f198f3005c3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7ea178eb65d7cd62834fdd2d335089d76e5db43c7a4ef31743b6e855c41a2294.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e3af48a72cbd424ccb70ba5dc8312b97937477a7127afe0cecab4f198f3005c3.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 453,
  isTopShop: true,
  isInsider: true,
  description:
    "Fast Shipping, Popular Brands! We hope you and your customers enjoy our products. Our unwavering commitment is to curate the finest beauty and skincare collections, always keeping affordability in mind. Should you have any inquiries, suggestions, or specific sourcing needs, please do not hesitate to reach out. Be sure to peruse our store regularly, as we continually introduce new items each month. If you ever need assistance with reorder decisions, our team is at your service.\n\nKindly drop us a message to receive our exclusive list of top-selling recommendations from the past quarter!\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:11.512Z",
    importedBy: "entity-db-cli",
  },
};
